// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionablePhotoController from "./actionable_photo_controller"
application.register("actionable-photo", ActionablePhotoController)

import ArtImageProductsController from "./art_image_products_controller"
application.register("art-image-products", ArtImageProductsController)

import BackButtonController from "./back_button_controller"
application.register("back-button", BackButtonController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContentToggleController from "./content_toggle_controller"
application.register("content-toggle", ContentToggleController)

import ConversionsController from "./conversions_controller"
application.register("conversions", ConversionsController)

import CustomValueFieldController from "./custom_value_field_controller"
application.register("custom-value-field", CustomValueFieldController)

import DaisyCarouselNavigationController from "./daisy_carousel_navigation_controller"
application.register("daisy-carousel-navigation", DaisyCarouselNavigationController)

import DisableFormWithCheckboxController from "./disable_form_with_checkbox_controller"
application.register("disable-form-with-checkbox", DisableFormWithCheckboxController)

import DownloadArtImagesController from "./download_art_images_controller"
application.register("download-art-images", DownloadArtImagesController)

import ExampleSubjectsController from "./example_subjects_controller"
application.register("example-subjects", ExampleSubjectsController)

import ExamplesController from "./examples_controller"
application.register("examples", ExamplesController)

import FieldCharacterCounterController from "./field_character_counter_controller"
application.register("field-character-counter", FieldCharacterCounterController)

import FilterStylesController from "./filter_styles_controller"
application.register("filter-styles", FilterStylesController)

import FinetuningFeedbackController from "./finetuning_feedback_controller"
application.register("finetuning-feedback", FinetuningFeedbackController)

import FinetuningStylePackSelectorController from "./finetuning_style_pack_selector_controller"
application.register("finetuning-style-pack-selector", FinetuningStylePackSelectorController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import GalleryImageController from "./gallery_image_controller"
application.register("gallery-image", GalleryImageController)

import GalleryLightboxController from "./gallery_lightbox_controller"
application.register("gallery-lightbox", GalleryLightboxController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeroSubjectController from "./hero_subject_controller"
application.register("hero-subject", HeroSubjectController)

import InAppBrowserController from "./in_app_browser_controller"
application.register("in-app-browser", InAppBrowserController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LineItemController from "./line_item_controller"
application.register("line-item", LineItemController)

import MetaPixelEventsController from "./meta_pixel_events_controller"
application.register("meta-pixel-events", MetaPixelEventsController)

import MiniGalleryController from "./mini_gallery_controller"
application.register("mini-gallery", MiniGalleryController)

import MissiveIntegrationController from "./missive_integration_controller"
application.register("missive-integration", MissiveIntegrationController)

import MockupController from "./mockup_controller"
application.register("mockup", MockupController)

import MultipleUploadController from "./multiple_upload_controller"
application.register("multiple-upload", MultipleUploadController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import NewsletterSyncController from "./newsletter_sync_controller"
application.register("newsletter-sync", NewsletterSyncController)

import PhotoController from "./photo_controller"
application.register("photo", PhotoController)

import PhotoCropperController from "./photo_cropper_controller"
application.register("photo-cropper", PhotoCropperController)

import PosthogController from "./posthog_controller"
application.register("posthog", PosthogController)

import ProductController from "./product_controller"
application.register("product", ProductController)

import ProductImageController from "./product_image_controller"
application.register("product-image", ProductImageController)

import ProductImagePreviewsController from "./product_image_previews_controller"
application.register("product-image-previews", ProductImagePreviewsController)

import ProductPreviewController from "./product_preview_controller"
application.register("product-preview", ProductPreviewController)

import PromptRatingsFormController from "./prompt_ratings_form_controller"
application.register("prompt-ratings-form", PromptRatingsFormController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import ShareApiController from "./share_api_controller"
application.register("share-api", ShareApiController)

import SignOutController from "./sign_out_controller"
application.register("sign-out", SignOutController)

import StylePacksIndexController from "./style_packs_index_controller"
application.register("style-packs-index", StylePacksIndexController)

import SubjectFormController from "./subject_form_controller"
application.register("subject-form", SubjectFormController)

import SubjectStylePacksIndexController from "./subject_style_packs_index_controller"
application.register("subject-style-packs-index", SubjectStylePacksIndexController)

import TiktokEventController from "./tiktok_event_controller"
application.register("tiktok-event", TiktokEventController)

import ToggleContentController from "./toggle_content_controller"
application.register("toggle-content", ToggleContentController)

import TurboFrameMissingRedirectController from "./turbo_frame_missing_redirect_controller"
application.register("turbo-frame-missing-redirect", TurboFrameMissingRedirectController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurboStreamPollingController from "./turbo_stream_polling_controller"
application.register("turbo-stream-polling", TurboStreamPollingController)
